/*
 * @Description: 
 * @Autor: dongliangke
 * @Date: 2024-04-24 14:01:46
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-02-17 10:47:02
 */
import request from '@/global/request'
import { AxiosResponse } from 'axios'
import { LoginFrom } from '@/types/views/login'
import { ResponseData } from '@/types/api/public'
import { LoginSuccess, UserInfo } from '@/types/api/login'
import util from '@/utils/util'
import qs from 'qs';

type ConfigType<T = ResponseData> = Promise<AxiosResponse<T>>

/**
 * @FunctionName:  登录获取token
 * @param {LoginFrom} data
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-06-07 10:41:27
 * @Description: 
 */
export const oauthToken = (data: LoginFrom): ConfigType<LoginSuccess> => {
  const formData = {
    'grant_type': 'password',
    'username': util.ASE_Login(data.username),
    'password': util.ASE_Login(data.password)
  };
  let headers:any = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': 'Basic Y3Foeno6d2hkc3Vuc29mdDgwMw==',
    'showError': false
  };
  // 请求头 新增 租户名称
  if ((window as any).serverConfig.IS_MULTI_TENANCY) {
    let tenantName = localStorage.getItem('tenantName');
    headers['tenantName'] = tenantName
  }
  return request({
    'url': 'paicoreuaa/oauth/token',
    'method': 'post',
    'headers': headers,
    'data': qs.stringify(formData)
  });
}

/**
 * @FunctionName: 获取用户信息
 * @param {LoginFrom} data
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-06-07 10:44:20
 * @Description: 
 */
export const getUserInfo = (data: LoginFrom): ConfigType<UserInfo> => {
  return request({
    'url': 'paicoreuaa/api/login',
    'method': 'post',
    'headers': {
      'showError': false,
    },
    'data': {
      'userName': util.ASE_Login(data.username),
      'password': util.ASE_Login(data.password)
    }
  });
}
/**
 * @FunctionName: 退出登录
 * @param {*} ConfigType
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-06-07 10:45:26
 * @Description: 
 */
export const logout = (): ConfigType => {
  return request({
    url: 'login/logout',
    method: 'post'
  });
}
/**
 * @FunctionName: 更根据 tokenId 自动登录 获取token
 * @param {any} headers
 * @param {any} params
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2024-07-02 15:28:34
 * @Description: 
 */
export const loginByTokenId = (headers: any, params: any): ConfigType => {
  // 根据 tokenId 自动登录
  return request({
    url: 'paicoreuaa/api/loginByTokenId',
    method: 'post',
    headers,
    data: params
  })
}